import React, { FunctionComponent } from 'react'
import styled, { keyframes } from 'styled-components'

export type LiveAnimationProps = {
    height?: number | string
    width?: number | string
}

const pulse = keyframes`
    0% {
        height: 55%;
        width: 55%;
    }

    50% {
        height: 80%;
        width: 80%;
    }

    100% {
        height: 55%;
        width: 55%;
    }
`

export const Dot = styled.div`
    animation: ${pulse} 1.4s ease-out infinite;
`

const LiveAnimation: FunctionComponent<LiveAnimationProps> = ({ height = 8, width = 8 }) => {
    height = Number(height)
    width = Number(width)
    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                height,
                justifyContent: 'center',
                width,
            }}
        >
            <div
                style={{
                    alignItems: 'center',
                    border: `${Math.ceil(width / 15)}px solid rgba(246, 168, 0, 0.2)`,
                    borderRadius: height + width,
                    display: 'flex',
                    height: height / 1.5,
                    justifyContent: 'center',
                    width: width / 1.5,
                }}
            >
                <Dot
                    style={{
                        background: 'rgb(246, 168, 0)',
                        borderRadius: height + width,
                        height: height / 3,
                        width: width / 3,
                    }}
                />
            </div>
        </div>
    )
}

export default LiveAnimation
